import { render, staticRenderFns } from "./confirmPoint.vue?vue&type=template&id=d92f0fe2&scoped=true"
import script from "./confirmPoint.vue?vue&type=script&lang=js"
export * from "./confirmPoint.vue?vue&type=script&lang=js"
import style0 from "./confirmPoint.vue?vue&type=style&index=0&id=d92f0fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92f0fe2",
  null
  
)

export default component.exports